import { cellRenderParseData } from '../../utils/functions';

const columnDataNotGP = [
  {
    dataField: 'dateOm',
    caption: 'Дата отгрузки Северсталь',
    cellRender: cellRenderParseData,
    dataType: 'date'
  }
];

export default columnDataNotGP;
